import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectIcons = (state: RootState) =>
  state.rootReducer.iconsStore.icons;
export const selectIsLoadingIcons = (state: RootState) =>
  state.rootReducer.iconsStore.isLoadingIcons;

export const selectIconsByCategory = (state: RootState) =>
  state.rootReducer.iconsStore.iconsByCategory;
export const selectIsLoadingIconsByCategory = (state: RootState) =>
  state.rootReducer.iconsStore.isLoadingIconsByCategory;

export const selectIconsState = createSelector(
  selectIcons,
  selectIsLoadingIcons,
  selectIconsByCategory,
  selectIsLoadingIconsByCategory,
  (icons, isLoadingIcons, iconsByCategory, isLoadingIconsByCategory) => ({
    icons,
    isLoadingIcons,
    iconsByCategory,
    isLoadingIconsByCategory
  })
);
